<div class="modal-header border-0 pb-0">
    <h5 class="modal-title font-weight-bold text-dark">{{ title }}</h5>
    <button type="button" class="close" (click)="cancel()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <app-change-preview 
        [oldData]="oldData" 
        [newData]="newData" 
        [config]="config" 
    />
</div>
<div class="modal-footer border-0 pt-0 justify-content-center pb-4">
    <ng-container *ngIf="mode === 'audit'; else editModeFooter">
        <button type="button" class="btn btn-light btn-round px-4" (click)="cancel()">Close</button>
    </ng-container>
    <ng-template #editModeFooter>
        <button type="button" class="btn btn-light btn-round px-4" (click)="cancel()">Cancel</button>
        <button type="button" class="btn btn-primary btn-round px-4 ml-2" (click)="confirm()">
            Confirm & Submit
        </button>
    </ng-template>
</div>
